<template>
    <div class="verificationCode">
         <div class="content-bg">
            <div style="margin-top: 15px;height:40px;">
                <span class="span-style"></span>
                <div class="border-style">版权核验</div>                         
                <span class="span-style"></span>
            </div>
            <p class="p-style">核验数据属于非公开信息，需输入核验码</p>
            <div style="text-align:center">
                <p><input v-model="code" class="text-input" type="text"  placeholder="请输入核验码"  /></p>
                <button @click="getVerifyCode" class="verifybtn">验证</button>
            </div>
        </div>
    </div>  
</template>

<script>
import { _getVerifyCode } from "@/api/wallet.js";
import Cookies from "js-cookie";
export default {
    metaInfo: {
        title: '版权核验|版权服务专家|版权家',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
        },{
            name: 'Description',
            content: '版权核验,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
        }]
    },
    name:'verificationCode',
    data(){
        return{
           code:"" 
        }
    },
    methods: {
        getVerifyCode(){
            const data ={
                businessType:this.$route.params.type,
                orderSeqNo:this.$route.params.id,
                verifyCode:this.code
            }
            _getVerifyCode(data).then(res => {
                if(res.code==200){
                    this.$emit('fatherModal');
                    this.$router.push({name:'creationVerification',query: {type:this.$route.params.type,id:this.$route.params.id}})
                }else{
                    toast(res.message)
                }                                                   
            });
        }
    }
}
</script>
<style scoped lang='less'>
.verificationCode{
    position: relative;
    width:1200px;
    margin:30px auto;
    .content-bg{
        position: relative;
        overflow:hidden;
        border-radius:8px;
        background: #fff;
        box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
        padding:40px 45px;
        .span-style{
            width: 413px;
            float: left;
            display: inline-block;
            height: 1px;
            background: #eaeaea;
            vertical-align: middle;
            margin-top: 19px;
        }
        .border-style{
            margin: 0;
            line-height: 38px;
            font-size: 24px;
            top: -10px;
            border-radius: 50px;
            width: 280px;
            float: left;
            border:1px solid #eaeaea;
            text-align: center;
            color:#000;
        }
        .p-style{
            text-align:center;
            color:#b8b8b8;
            margin-top:25px;
            margin-bottom:90px;
            font-size: 16px;
        }
        .text-input{
            width:335px;
            height:42px;
            line-height: 42px;
            outline: none;
            background:rgba(255,255,255,1);
            border-radius:4px;
            border:1px solid #eaeaea;
            text-indent: 15px;
        }
        .verifybtn{
            width:150px;
            height:37px;
            line-height: 37px;
            border:0;
            background:rgba(255,216,0,1);
            border-radius:21px;
            outline: none;
            font-size:14px;
            font-weight:600;
            color:rgba(78,78,78,1);
            cursor: pointer;
            margin:100px 0px;
        }
    }
}
</style>